export const errorMessage = {
    "USER_NOT_AUTHENTICATED": "Authenticated.",
    "USER_NOT_FOUND": "User not found.",
    "NOT_EXITS_PHONE_NUMBER": "sorry, not exits phone number.",
    "USER_CANT_ACCESS_AN_EXAM": "sorry, your phone number is not on the list.",
    "NOT_GRANTED": "sorry, your phone number is not granted.",
    "FAIL_TO_CREATE_TOKEN": "Something was wrong, Please refresh page and try again.",
    "GET_PHONE_NUMBER_BY_UUID_ERROR": "Something was wrong, Please refresh page and try again.",
    "TEST_NOT_START": "Test not start, please comeback later.",
    "TEST_TIME_OUT": "Sorry, test time out.",
    "OUT_OF_TRYTIMES": "Sorry, out of try times.",
    "TEST_NOT_EXISTED": "Test is being updated, please comeback later.",
    "TESTS_NOT_FOUND": "Test is being updated, please comeback later.",
    "TEST_NOT_QUESTIONS": "This test have no question, please comeback later.",
    "SOME_THING_IS_WRONG": "Something was wrong, please comeback later.",
    "LESSON_NOT_FOUND": "Lesson not found, please comeback later.",
    "LESSON_NOT_STARTED": "Lesson not start, please comeback later.",
    "PREVIOUS_LESSON_NOT_COMPLETE": "You have not completed the prerequisite lessons, study on the right track",
    "QUESTION_NOT_ENOUGH": "The Question is being updated, please comeback later.",
    "ANSWERS_SUBMIT_NULL": "Answer null, please try later.",
    "QUESTION_TYPE_NOT_FOUND": "Question type not found.",
    "TEST_CODE_NOT_FOUND": "Test code not found",
    "TL_CODE_NULL": "T code or L code null, please comeback later.",
    "ANONYMOUS_AUTHENTICATION_TOKEN": "Hello! Sorry, your phone number is not on the list.",
    "NO_NETWORK": "No network",
};
